import { Box } from '@mui/material'
import dayjs from 'dayjs'
import { getIcon } from 'utils/get-icon'
import { IDate } from "./types"
import { useStyles } from './styles'

interface IProps {
  dates: IDate[]
}

export function GraphDates({ dates }: IProps) {
  const classes = useStyles()

  const formatDate = (date: Date | null): string => {
    if (!date) {
      return dayjs().format('--/--/---- --:--')
    }
    return dayjs(date).add(3, 'hour').format('DD/MM/YYYY HH:mm')
  }

  const getOriginDisplayName = (origin: string): string => {
    const originMap: Record<string, string> = {
      'ESOCIAL': 'eSocial',
      'PJ': 'Pessoa Jurídica',
      'MISSING_DATA': 'Dados Faltantes'
    }
    return originMap[origin] || origin
  }

  const sortedDates = [...dates].filter((d) => d.origin === 'ESOCIAL')

  return (
    <Box className={classes.root}>
      {sortedDates.map((dateInfo, index) => (
        <>
          <Box key={dateInfo.origin} className={classes.dataSourceRow}>
            <Box className={classes.item}>
              <h3>Fonte de dados</h3>
              <div>
                {getIcon(dateInfo.origin === 'ESOCIAL' ? "e-social" : 'snowflake')}
                <p>{getOriginDisplayName(dateInfo.origin)}</p>
              </div>
            </Box>

            <hr className={classes.divider} />

            <Box className={classes.item}>
              <h3>Atualizado em</h3>
              <span>{formatDate(dateInfo.executedAt)}</span>
            </Box>

            {dateInfo.origin === 'ESOCIAL' && (
              <>
                <hr className={classes.divider} />

                <Box className={classes.item}>
                  <h3>Próxima atualização</h3>
                  <span>{formatDate(dateInfo.scheduledAt)}</span>
                </Box>
              </>
            )}
          </Box>

          {index < sortedDates.length - 1 && (
            <Box sx={{ width: '100%', height: '1px', backgroundColor: '#E0E0E0', margin: '1rem 0' }} />
          )}
        </>
      ))}
    </Box>
  )
}
